import { render, staticRenderFns } from "./app-profile-user-form.vue?vue&type=template&id=4be7b864&scoped=true&"
import script from "./app-profile-user-form.vue?vue&type=script&lang=js&"
export * from "./app-profile-user-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7b864",
  null
  
)

export default component.exports